export const AUTOFILL_CHECK_TIMEOUT = 300

export const DEFAULT_RESEND_COOLDOWN_SECONDS = 120
// TODO: change to 30 seconds
export const YETTEL_SERBIA_RESEND_COOLDOWN_SECONDS = 30
